exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".smaller-text[data-v-7f50753e]{margin:0;font-size:1rem}", ""]);

// exports
